import { createApp } from 'vue'

import 'element-plus/dist/index.css'
import 'styles/reset.css'

import App from './App.vue'
import router from './router'
import store from './store'
import { createI18n } from 'vue-i18n'
// 路由守卫
import './route.guard'
const app = createApp(App)

import en from './lang/locales/en.json'
import zh from './lang/locales/zh.json'
// 创建i18n实例并设置默认语言和可用语言选项
const i18n = createI18n({
  legacy: false,
  locale: 'en', // 设置默认语言为英语
  fallbackLocale: 'en', // 设置后备语言为英语，以防当前语言缺失某些翻译项
  globalInjection: true,
  messages: {
    en, // 英语翻译文件
    zh // 中文翻译文件
  }
})

app.use(i18n)
app.use(store)
app.use(router)

app.mount('#app')
